import LineGraph from "../../LineGraph";
import ArrivalRatesPerDayTable from "../tables/ArrivalRatesPerDayTable";

import { Box, Separator } from "@chakra-ui/react";
import TimeOfDayChart from "../../TimeOfDayChart";
import { useSelector } from "react-redux";
import { normalizeArrivalRatesPerHourReport } from "../../../store/arrivalRates";
import * as defaultSelectors from "../../../store/selectors/defaultSelector";
import {
  ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
  normalizeRenderConfig,
} from "../../../store/renderConfig";
import { formatNumber } from "../../../store/helpers";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildArrivalInsights } from "../../../store/reportEnterpriseInsights";
import ConfiguredReportTable from "../../reports/ConfiguredReportTable";

const renderCell = (row, columnId) => {
  if (columnId === "scopeName") return row.scopeName;
  if (columnId === "total") return formatNumber(row.total);
  if (columnId === "average") return formatNumber(row.average);
  if (columnId === "min") return formatNumber(row.min);
  if (columnId === "max") return formatNumber(row.max);
  return null;
};

const ArrivalRatesPerHour = ({ reportIndex = 1, data: rawReportData }) => {
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  const config = normalizeRenderConfig(renderConfig, {
    columnDefinitions: ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
  });
  const title = `${reportIndex}.1. Entire Organization`;
  const { hoursPerDay } = useSelector((store) => store.defaultReducer);
  const reportData = normalizeArrivalRatesPerHourReport(rawReportData, hoursPerDay);
  const { average, min, max, total, chart, timeOfDayChart } = reportData;
  const insights = buildArrivalInsights(
    [{ ...reportData, scopeName: "Entire Organization" }],
    { scopeLabel: "Organization" }
  );
  if (!config.charts.enabled) {
    const row = { ...reportData, scopeName: "Entire Organization" };
    return (
      <Box className="reportTableContainer arrivalRatesSummaryBlock" mt="20px">
        <EnterpriseReportSummary
          title="Hourly Arrival Demand Summary"
          kpis={insights.kpis}
          tables={insights.tables}
          notes={insights.notes}
        />
        <ConfiguredReportTable
          columns={ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS}
          rows={[row]}
          renderConfig={config}
          renderCell={renderCell}
        />
      </Box>
    );
  }

  return (
    <>
      <Box>
        <Box className="reportContainer" mt="20px">
          <EnterpriseReportSummary
            title="Hourly Arrival Demand Summary"
            kpis={insights.kpis}
            tables={insights.tables}
            notes={insights.notes}
          />
          <ArrivalRatesPerDayTable
            average={average}
            min={min}
            max={max}
            total={total}
            title={title}
          />

          <LineGraph
            chart={chart}
            height={"300px"}
            lineName={"Avg / Hour"}
            title={"Entire Organization Arrival Rates Per Hour, Day by Day Comparison"}
          />
        </Box>
        <Separator />
        <Box mt="20px" mb="20px" className="reportContainer">
          <TimeOfDayChart {...timeOfDayChart} title={"Time of Day Chart"} />
        </Box>
      </Box>
    </>
  );
};

export default ArrivalRatesPerHour;
